import React from 'react';
import { ThunkAction } from 'redux-thunk';
import { AnyAction } from '@reduxjs/toolkit';
import apolloClient from '@src/graphql/apollo';
import { OpeningsLimitReachedModal, UpgradeSubscriptionModal } from '@src/containers/SubscriptionModals';
import { setModalContent } from '@src/redux/actions/modal';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { isLimitedSlotSubscription, isSlotBasedSubscription } from '@src/util/planTypes';
import { PublishOpeningModal } from '@src/containers/SubscriptionModals/PublishOpening';
import { RootState } from '@src/redux/interfaces/redux.interface';
import { CustomerDocument } from '@src/graphql/generated';
import { checkOpeningLimitParams } from './interfaces/checkOpeningLimit.interface';

/**
 * checks if user has reached their maximum amount of openings, opens "subscribe more" modal or
 * executes callback function:
 * @param {Function} nextFunction function to be executed after subscription type check
 */
export const checkOpeningLimit = ({
  nextFunction,
}: checkOpeningLimitParams): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    try {
      const {
        data: {
          customer: {
            planType,
            planInfo: { hasOpeningsLimitReached },
          },
        },
      } = await apolloClient.query({
        fetchPolicy: 'network-only',
        query: CustomerDocument,
      });

      if (hasOpeningsLimitReached) {
        dispatch(
          setModalContent({
            content: isSlotBasedSubscription(planType) ? (
              <OpeningsLimitReachedModal nextFunction={nextFunction} />
            ) : isLimitedSlotSubscription(planType) ? (
              <PublishOpeningModal nextFunction={nextFunction} />
            ) : (
              <UpgradeSubscriptionModal hasOpeningsLimitReached nextFunction={nextFunction} />
            ),
          }),
        );
      } else {
        if (nextFunction) {
          await nextFunction();
        }
      }
    } catch (e) {
      dispatch(setErrorFlashMessage());
    }
  };
};
